import React, { useEffect, useState, useContext } from "react";
import api from "../../axios/api.js";
import { useParams } from "react-router-dom";
import PopupMap from "../features/PopupMap.jsx";
import { GlobalContext } from "../../contexts/GlobalContext";
import TreePlantationCoverPic from '../../assets/images/newassets/treeplantationCoverPic.jpg';
import imageCompression from "browser-image-compression";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader.js";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TagsInput from "react-tagsinput";
import Loader from "../common/Loader.jsx";
import Button from "../common/styled components/Button.jsx";

const EditProjectPage = () => {
  const {
    address,
    setAddress,
    latlng,
    setLatlng,
    country,
    addressData,
    role, userId, isLoggedIn
  } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [organizationsOptions, setOrganizationsOptions] = useState([]);
  const [project, setProject] = useState({});
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [coverPhotoPreview, setCoverPhotoPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [tags, setTags] = useState([]);
  const [listing_order,setListing_order] = useState([]);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [invalidFields, setInvalidFields] = useState([]);
  const { id } = useParams();
  const [esgOptions] = useState([
    { index: 1, value: "No Poverty", label: "No Poverty" },
    { index: 2, value: "Zero Hunger", label: "Zero Hunger" },
    {
      index: 3,
      value: "Good Health And Well Being",
      label: "Good Health And Well Being",
    },
    { index: 4, value: "Quality Education", label: "Quality Education" },
    { index: 5, value: "Gender Equality", label: "Gender Equality" },
    {
      index: 6,
      value: "Clean Water And Sanitation",
      label: "Clean Water And Sanitation",
    },
    {
      index: 7,
      value: "Affordable And Clean Energy",
      label: "Affordable And Clean Energy",
    },
    {
      index: 8,
      value: "Decent Work And Economic Growth",
      label: "Decent Work And Economic Growth",
    },
    {
      index: 9,
      value: "Industry-Innovation and Infrastructure",
      label: "Industry, Innovation and Infrastructure",
    },
    { index: 10, value: "Reduced Inequalities", label: "Reduced Inequalities" },
    {
      index: 11,
      value: "Sustainable Cities And Communities",
      label: "Sustainable Cities And Communities",
    },
    {
      index: 12,
      value: "Responsible Consumption And Production",
      label: "Responsible Consumption And Production",
    },
    { index: 13, value: "Climate Action", label: "Climate Action" },
    { index: 14, value: "Life Below Water", label: "Life Below Water" },
    { index: 15, value: "Life On Land", label: "Life On Land" },
    {
      index: 16,
      value: "Peace-Justice and Strong Institutions",
      label: "Peace, Justice and Strong Institutions",
    },
    {
      index: 17,
      value: "Partnerships For The Goals",
      label: "Partnerships For The Goals",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);

  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: "",
    component: null
  });

  // Function to handle modal opening with different components
  const openModal = (title, component) => {
    setModalConfig({
      isOpen: true,
      title,
      component
    });
  };

  // Function to handle modal closing
  const closeModal = () => {
    setModalConfig({
      isOpen: false,
      title: "",
      component: null
    });
  };

  const renderComponent = () => {
    const Component = modalConfig.component;
    return Component ? <Component onClose={closeModal} /> : null;
  };

  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 1,
      useWebWorker: true,
    };
    const compressedFile = await imageCompression(file, options);
    return compressedFile
  }


  // Fetch organizations and project details
  useEffect(() => {
    const fetchOrganizationsAndProject = async () => {
      setIsLoading(true); // Set loading state to true
      try {
        const orgResponse = await api.get("/api/user/organizations");
        if (orgResponse.data && orgResponse.data.length > 0) {
          const orgOptions = orgResponse.data[0].map((org) => ({
            value: org.id,
            label: org.company_name,
            created_by_user: org.created_by_user,
          }));

          const filteredOptions = (role === 'corporate' || role === "ngo")
            ? orgOptions.filter((organization) => organization.created_by_user === userId)
            : role === 'admin'
              ? orgOptions
              : [];

          setOrganizationsOptions(filteredOptions);

          // Fetch project details after setting organization options
          await fetchProjectDetails(filteredOptions);
        }
      } catch (error) {
        console.error("Error fetching organizations:", error);
      } finally {
        setIsLoading(false); // Set loading state to false after fetching
      }
    };

    fetchOrganizationsAndProject();
  }, [role, userId, id]);


  const fetchProjectDetails = async (orgOptions) => {
    setIsLoading(true); // Set loading state to true
    try {
      const response = await api.get(`/api/project/getProjectEditDetails/${id}`);
      const projectData = response.data.project;
      setProject(projectData);
      setCoverPhotoPreview(projectData.project_cover_image);
      setAddress(projectData.address);
      setLatlng({ lat: projectData.lat, lng: projectData.longi });
     setListing_order(projectData.listing_order);
   
      const tags = projectData.tags ? projectData.tags.split(',') : [];
      setTags(tags);

      // Set ESG Goals
      const esgGoalsArray = projectData.esgGoals ? projectData.esgGoals.split(',') : [];
      const selectedGoals = esgGoalsArray
        .map(goal => esgOptions.find(option => option.value === goal))
        .filter(Boolean);
      setSelectedGoals(selectedGoals);

      // Set Organizations
      const companyIdsArray = projectData.companyIds ? projectData.companyIds.split(',') : [];
      const selectedOrgs = companyIdsArray
        .map(companyId => orgOptions.find(option => option.value.toString() === companyId))
        .filter(Boolean);
      setSelectedOrganizations(selectedOrgs);
    } catch (error) {
      console.error("Error fetching project details:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleChange = (e) => {
    if (e.target.name === "target") {
      const nodecimalregex = /^\d*$/;
      if (nodecimalregex.test(e.target.value)) {
        setProject({
          ...project,
          [e.target.name]: e.target.value,
        });
      } else {
        return;
      }
    } else {
      setProject({
        ...project,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleCoverPicChange = (e) => {
    const file = e.target.files[0];
    setCoverPhoto(file);
    setCoverPhotoPreview(URL.createObjectURL(file));
  };

 const handleSave = async () => {
  if (!isLoggedIn) {
    toast.error("Please log in to create a project");
    setTimeout(() => {
      navigate("/login"); // Redirect to the login page after delay
    }, 1000);
    return;
  }

  const requiredFields = ['name', 'startDate', 'endDate', 'description', 'target', 'address', 'selectedOrganizations', 'selectedGoals', 'coverPhoto','listing_order'];
  const invalids = [];

  // Check required fields
  if (!project.name) invalids.push("projectName");
  if (!project.startDate) invalids.push("startDate");
  if (!project.endDate) invalids.push("endDate");
  if (!project.description) invalids.push("Desc");
  if (!project.target) invalids.push("target");
  if (!address) invalids.push("address");
  if (selectedOrganizations.length === 0) invalids.push("Orgs");
  if (selectedGoals.length === 0) invalids.push("goals");
  if (!coverPhoto && !coverPhotoPreview) invalids.push("cover");
  if (tags.length === 0) invalids.push("tags");
  if (!project.listing_order === 0) invalids.push("listing_order");

  setInvalidFields(invalids);

  if (invalids.length > 0) {
    toast.error("Please fill in all required fields.");
    return; // Stop form submission if there are invalid fields
  }

  setIsSubmitting(true);
  const formData = new FormData();

  if (coverPhoto) {
    const compressedCover = await compressImage(coverPhoto);
    formData.append('projectCoverImage', compressedCover);  // Change field name
    formData.append('coverImageName', coverPhoto.name);
  }

  const sortedGoals = selectedGoals.sort((a, b) => a.index - b.index);

  // Append other project details
  Object.keys(project).forEach((key) => {
    formData.append(key, project[key]);
  });
  formData.set("lat", latlng.lat);
  formData.set("longi", latlng.lng);
  formData.append("city", addressData.city);
  formData.append("country", country);
  formData.append("state", addressData.state);
  formData.append("post_code", addressData.postcode);
  formData.set("address", address);
  formData.set("tags", tags);
  formData.append("listing_order", project.listing_order);
  // formData.set("esgGoals",selectedGoals.map((val)=>val.value));
  formData.set("esgGoals", sortedGoals.map((val) => val.value));
  formData.set("companyIds", selectedOrganizations.map((val) => val.value));
  formData.set("organizationName", selectedOrganizations.map((val) => val.label));

  setIsLoading(true); // Set loading state to true
  try {
    await api.post(`/api/project/updateProject/${project.project_id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    //  Delay navigation slightly so toast is visible
    setTimeout(() => {
      navigate(`/dashboard/projectdashboard`);
    }, );
  } catch (error) {
    console.error("Error updating project:", error);
    toast.error("Error updating project.");
  } finally {
    setIsLoading(false); // Set loading state to false after fetching
    setIsSubmitting(false);
  }
};

  const onCancelClick = async () => {
    setAddress("")
    setLatlng(null)
    navigate("/dashboard/projectdashboard")
  }

  const getInvalidStyle = (fieldName) => {
    return invalidFields.includes(fieldName) ? "border-2 border-red-500" : "";
  };

  // Custom styles for react-select
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '50px',
      borderColor: '#cbd5e0',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#a0aec0',
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: '#4a5568',
    }),
    placeholder: (base) => ({
      ...base,
      color: '#a0aec0',
    }),
  };

  // Add Tailwind classes to react-tagsinput
  const tagsInputStyles = {
    className: "react-tagsinput rounded border border-gray-300 p-2 w-full min-h-[50px]",
    tagClassName: "react-tagsinput-tag bg-blue-600 text-white rounded px-2 py-1 m-1",
    inputClassName: "react-tagsinput-input p-1 mt-1"
  };
  return (
    <div className="w-11/12 max-w-5xl mx-auto my-4 flex flex-col gap-4 font-sans text-sm">
      <ToastContainer />

      {isLoading && (
        <div className="fixed inset-0 bg-white bg-opacity-70 z-50 flex justify-center items-center">
          <Loader />
        </div>
      )}

      <div className={`${isLoading ? 'pointer-events-none opacity-60 transition-opacity duration-300' : ''}`}>
        {/* Back Button */}
        <Button
          onClick={() => navigate(-1)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to Projects
        </Button>

        <Dialog
          open={modalConfig.isOpen}
          onClose={closeModal}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            {modalConfig.title}
            <IconButton
              onClick={closeModal}
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {renderComponent()}
          </DialogContent>
        </Dialog>

        <div className="flex flex-col items-center gap-3 mb-2">
          <div
            className="relative w-full max-w-md cursor-pointer group"
            onClick={() => document.getElementById('cover-upload-input')?.click()}
          >
            {/* Image */}
            <img
              src={coverPhotoPreview || TreePlantationCoverPic}
              alt="Cover Pic"
              className={`w-full h-48 object-cover rounded-lg shadow-md ${getInvalidStyle("cover")}`}
            />

            {/* Gray overlay on hover */}
            <div className="absolute inset-0 bg-transparent group-hover:bg-black/20 transition-all duration-300 rounded-lg" />

            {/* Persistent bottom text with semi-transparent background */}
            <div className="absolute bottom-0 left-0 right-0 bg-black/40 text-white text-sm text-center p-2 rounded-b-lg z-10">
              Change cover image
            </div>

            {/* Hidden file input */}
            <input
              id="cover-upload-input"
              type="file"
              accept="image/*"
              onChange={handleCoverPicChange}
              className="hidden"
            />

            {/* Error icon if invalid */}
            {invalidFields.includes("cover") && (
              <div className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full z-20">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
            )}
          </div>
        </div>



        {/* Project Details Form */}
        <div className="bg-gray-50 p-4 md:p-5 rounded-lg shadow-md">
          <p className="text-xs mb-3">NOTE: fields marked with <span className="text-red-500">*</span> are mandatory to input.</p>

          {/* First Row - Project Name, Start Date, End Date */}
          <div className="flex flex-col md:flex-row gap-3 mb-4">
            <div className="flex flex-col w-full">
              <label htmlFor="projectName" className="mb-1 text-gray-700 font-medium">
                Project Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={project.name || ""}
                onChange={handleChange}
                className={`w-full p-2 rounded border border-gray-300 ${getInvalidStyle("projectName")}`}
                placeholder="Project Name"
              />
            </div>

            <div className="flex flex-col w-full">
              <label htmlFor="projectStartDate" className="mb-1 text-gray-700 font-medium">
                Project Start Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                name="startDate"
                value={project.startDate || ""}
                onChange={handleChange}
                className={`w-full p-2 rounded border border-gray-300 ${getInvalidStyle("startDate")}`}
              />
            </div>

            <div className="flex flex-col w-full">
              <label htmlFor="projectEndDate" className="mb-1 text-gray-700 font-medium">
                Project End Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                name="endDate"
                value={project.endDate || ""}
                onChange={handleChange}
                className={`w-full p-2 rounded border border-gray-300 ${getInvalidStyle("endDate")}`}
              />
            </div>
              <div className="flex flex-col w-full">
            <label htmlFor="listingOrder" className="mb-1 text-gray-700 font-medium">
              Listing Order <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              name="listing_order"
              value={project.listing_order || ""}
              onChange={handleChange}
              placeholder="Listing Order"
              className={`w-full p-2 rounded border border-gray-300 ${getInvalidStyle("listing_order")}`}
            />
          </div>
          </div>

          {/* Description Row */}
          <div className="mb-4">
            <div className="flex flex-col w-full">
              <label htmlFor="projectDescription" className="mb-1 text-gray-700 font-medium">
                Project Description <span className="text-red-500">*</span>
              </label>
              <textarea
                name="description"
                value={project.description || ""}
                onChange={handleChange}
                placeholder="Project Description"
                className={`w-full p-2 rounded border border-gray-300 min-h-[100px] resize-y ${getInvalidStyle("Desc")}`}
              />
            </div>
          </div>

          {/* Tree Target, Organizations, ESG Goals Row */}
          <div className="flex flex-col md:flex-row gap-3 mb-4">
            <div className="flex flex-col w-full">
              <label htmlFor="projectTreeTarget" className="mb-1 text-gray-700 font-medium">
                Tree Target <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                name="target"
                value={project.target || ""}
                onChange={handleChange}
                placeholder="Target"
                className={`w-full p-2 rounded border border-gray-300 ${getInvalidStyle("target")}`}
              />
            </div>

            <div className="flex flex-col w-full">
              <label className="mb-1 text-gray-700 font-medium">
                Organizations <span className="text-red-500">*</span>
              </label>
              <Select
                options={organizationsOptions}
                isMulti
                value={selectedOrganizations}
                onChange={(selectedOptions) => setSelectedOrganizations(selectedOptions)}
                styles={{
                  ...selectStyles,
                  control: (base) => ({
                    ...selectStyles.control(base),
                    minHeight: '38px',
                    ...(invalidFields.includes("Orgs") ? { borderColor: '#f56565', borderWidth: '2px' } : {})
                  })
                }}
              />
            </div>

            <div className="flex flex-col w-full">
              <label htmlFor="projectESGGoals" className="mb-1 text-gray-700 font-medium">
                Project ESG Goals <span className="text-red-500">*</span>
              </label>
              <Select
                options={esgOptions}
                isMulti
                value={selectedGoals}
                onChange={(selectedOptions) => setSelectedGoals(selectedOptions)}
                styles={{
                  ...selectStyles,
                  control: (base) => ({
                    ...selectStyles.control(base),
                    minHeight: '38px',
                    ...(invalidFields.includes("goals") ? { borderColor: '#f56565', borderWidth: '2px' } : {})
                  })
                }}
              />
            </div>
          </div>

          {/* Tags Row - With Custom Styling for the Cross Button */}
          <div className="mb-4">
            <label className="mb-1 text-gray-700 font-medium">
              Tags <span className="text-red-500">*</span>
            </label>
            <div className={`${invalidFields.includes("tags") ? "border-2 border-red-500 rounded" : ""}`}>
              <TagsInput
                value={tags}
                onChange={setTags}
                className="react-tagsinput rounded border border-gray-300 p-2 w-full min-h-[38px]"
                tagProps={{
                  className: "react-tagsinput-tag bg-blue-600 text-white rounded px-2 py-1 m-1 flex items-center",
                  removeButtonStyle: {
                    fontSize: '16px',
                    color: 'white',
                    padding: '0 6px',
                    marginLeft: '8px',
                    cursor: 'pointer',
                    background: 'rgba(0,0,0,0.2)',
                    borderRadius: '50%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '20px',
                    height: '20px'
                  }
                }}
                inputProps={{
                  className: "react-tagsinput-input p-1",
                  placeholder: "Add a tag"
                }}
              />
            </div>
          </div>

          {/* Project Location Row */}
          <div className="flex flex-col md:flex-row items-center gap-2 mb-4">
            <label htmlFor="projectLocation" className="text-gray-700 font-medium whitespace-nowrap">
              Project Location <span className="text-red-500">*</span>
            </label>
            <div className="flex w-full gap-2">
              <input
                type="text"
                placeholder="Select Location From Map"
                value={address}
                readOnly
                className={`flex-1 p-2 rounded border border-gray-300 cursor-pointer ${getInvalidStyle("address")}`}
                onClick={() => openModal("Select Location", PopupMap)}
              />

              <button
                type="button"
                className="fa-solid"
                onClick={() => openModal("Select Location", PopupMap)}
                style={{
                  height: "50px",
                  paddingRight: "55px",
                  paddingLeft: "55px",
                  marginBottom: "20px",
                  marginTop: "0px",
                  backgroundColor: "#3E6294",
                  color: "white"
                }}
                tabIndex={3}
                disabled={isSubmitting}
              >
                📍
              </button>

            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-wrap gap-3 mt-4">
            <Button
              disabled={isSubmitting}
              onClick={handleSave}
            >
              {isSubmitting ? (
                <ClipLoader color="white" size='16' />
              ) : (
                "Save Changes"
              )}
            </Button>

            <Button
              disabled={isSubmitting}
              onClick={onCancelClick}
              variant="cancel"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditProjectPage;